import React, { useState, useEffect } from "react";
import axios from "axios";
import { API_URL } from "../../config/api";

function ContactAdmin() {
  const [data, setData] = useState({
    name: "",
    gender: "",
    email: "",
    age: "",
  });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ type: "", text: "" });

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const response = await axios.get(`${API_URL}/contact`);
      if (response.data.success) {
        setData(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching contact:", error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage({ type: "", text: "" });

    try {
      const token = localStorage.getItem("adminToken");
      const response = await axios.put(`${API_URL}/contact`, data, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response.data.success) {
        setMessage({
          type: "success",
          text: "Contact info updated successfully!",
        });
      }
    } catch (error) {
      setMessage({
        type: "error",
        text: error.response?.data?.message || "Update failed",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="space-y-4 sm:space-y-6">
      <h2 className="text-xl sm:text-2xl font-light mb-4 sm:mb-6">
        Edit Contact Information
      </h2>

      <form onSubmit={handleSubmit} className="space-y-4 sm:space-y-6">
        <div>
          <label className="block text-white/60 text-xs sm:text-sm mb-2">
            Name
          </label>
          <input
            type="text"
            value={data.name}
            onChange={(e) => setData({ ...data, name: e.target.value })}
            className="w-full px-3 sm:px-4 py-2.5 sm:py-3 bg-white/[0.05] border border-white/[0.1] rounded-lg sm:rounded-xl text-white text-sm sm:text-base
                     focus:outline-none focus:border-white/30 transition-all"
            required
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6">
          <div>
            <label className="block text-white/60 text-xs sm:text-sm mb-2">
              Gender
            </label>
            <input
              type="text"
              value={data.gender}
              onChange={(e) => setData({ ...data, gender: e.target.value })}
              className="w-full px-3 sm:px-4 py-2.5 sm:py-3 bg-white/[0.05] border border-white/[0.1] rounded-lg sm:rounded-xl text-white text-sm sm:text-base
                       focus:outline-none focus:border-white/30 transition-all"
              required
            />
          </div>

          <div>
            <label className="block text-white/60 text-xs sm:text-sm mb-2">
              Age
            </label>
            <input
              type="text"
              value={data.age}
              onChange={(e) => setData({ ...data, age: e.target.value })}
              className="w-full px-3 sm:px-4 py-2.5 sm:py-3 bg-white/[0.05] border border-white/[0.1] rounded-lg sm:rounded-xl text-white text-sm sm:text-base
                       focus:outline-none focus:border-white/30 transition-all"
              required
            />
          </div>
        </div>

        <div>
          <label className="block text-white/60 text-xs sm:text-sm mb-2">
            Email
          </label>
          <input
            type="email"
            value={data.email}
            onChange={(e) => setData({ ...data, email: e.target.value })}
            className="w-full px-3 sm:px-4 py-2.5 sm:py-3 bg-white/[0.05] border border-white/[0.1] rounded-lg sm:rounded-xl text-white text-sm sm:text-base
                     focus:outline-none focus:border-white/30 transition-all"
            required
          />
        </div>

        {message.text && (
          <div
            className={`p-4 rounded-lg ${
              message.type === "success"
                ? "bg-green-500/10 border border-green-500/20 text-green-400"
                : "bg-red-500/10 border border-red-500/20 text-red-400"
            }`}
          >
            {message.text}
          </div>
        )}

        <button
          type="submit"
          disabled={loading}
          className="w-full py-2.5 sm:py-3 bg-white/10 border border-white/20 rounded-lg sm:rounded-xl hover:bg-white/20 
                   transition-all disabled:opacity-50 disabled:cursor-not-allowed text-sm sm:text-base"
        >
          {loading ? "Updating..." : "Update Contact Info"}
        </button>
      </form>
    </div>
  );
}

export default ContactAdmin;
